import "./Holding.css";

import { DealArrowsIcon } from "../../../../assets";

export const Holding = (): JSX.Element => (
  <div className="HoldingContainer">
    <div className="HoldingContent">
      <div className="HoldingSpinner">
        <div className="HoldingSpinnerPulse">
          <svg className="HoldingSpinnerSvg" viewBox="0 0 160 160" role="img" aria-hidden="true">
            <defs>
              <linearGradient
                id="holdingSpinnerGradient"
                x1="0"
                y1="0"
                x2="160"
                y2="160"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0%" stopColor="var(--color-mint-green-600)" />
                <stop offset="100%" stopColor="var(--color-mint-green-100)" />
              </linearGradient>
            </defs>
            <circle className="HoldingSpinnerTrack" cx="80" cy="80" r="64" />
            <circle
              className="HoldingSpinnerRing"
              cx="80"
              cy="80"
              r="64"
              stroke="url(#holdingSpinnerGradient)"
              strokeDasharray="234.57 402.12"
            />
          </svg>
        </div>
        <div className="HoldingSpinnerIcon">
          <DealArrowsIcon />
        </div>
      </div>
      <div className="HoldingText">
        <h2>Creating your deal</h2>
        <p>This will only take a moment...</p>
      </div>
    </div>
  </div>
);
